import { gql } from "@apollo/client";

// Get employees
const EMPLOYEE_LIST = gql`
  query getEmployeeList($data: EmployeeFilterInput) {
    getEmployeelist(data: $data) {
      status
      message
      employee {
        id
        fullName
      }
    }
  }
`;
const CREATE_USER = gql`
  mutation CreateUser($data: createuserInput!) {
    createuser(data: $data) {
      status
      message
    }
  }
`;
const UPDATE_USER = gql`
  mutation updateCustomer($data: updateCustomerInput!) {
    updateCustomer(data: $data) {
      status
      message
    }
  }
`;
// Get user by phone
const GET_USER_BY_PHONE = gql`
  query getUserlist($contactNumber: String!) {
    getUserlist(data: { contactNumber: $contactNumber }) {
      status
      message
      user {
        id
        fullName
        contactNumber
        gender
        address {
          flatNo
          apartment
        }
      }
    }
  }
`;
// Get available services
const GET_SERVICES = gql`
  query getAdminService($data: Filter!) {
    getAdminService(data: $data) {
      services {
        id
        name
        price
        gender
        time
        specialPrice
        firstTimePrice
      }
    }
  }
`;
// Create booking
const CREATE_BOOKING = gql`
  mutation createBooking($data: CreateBookingInput!) {
    createbooking(data: $data) {
      status
      message
    }
  }
`;

// Prerequisite checklist items applicable to a set of selected services
const GET_PREREQUISITE_CHECKLIST_ITEMS = gql`
  query getPrerequisiteChecklistItemsForServices($serviceIds: [ID!]!) {
    getPrerequisiteChecklistItemsForServices(serviceIds: $serviceIds) {
      id
      title
      description
    }
  }
`;
const EDIT_BOOKING = gql`
  mutation editBooking($data: editBookingInput!) {
    editBooking(data: $data) {
      status
      message
    }
  }
`;

const DELETE_BOOKING = gql`
  mutation deleteBookings($data: ID!) {
    deleteBookings(data: $data) {
      status
      message
    }
  }
`;

const GET_AVAILABLE_EMPLOYEE = gql`
  query getAvailableEmployee($data: getAvailableEmployeeInput!) {
    getAvailableEmployee(data: $data) {
      status
      message
      employees
    }
  }
`;
const GET_AVAILABLE_SLOTS = gql`
  query getAvailableSlots($data: getAvailableSlotsInput) {
    getAvailableSlots(data: $data) {
      slots
      employeeIds
    }
  }
`;

const GET_BOOKINGS = gql`
  mutation getBookings($data: BookingsFilterInput) {
    getBookings(data: $data) {
      status
      message
      orders {
        id
        price
        totalPrice
        status
        address
        gender
        bookingDate
        timeSlot
        paymentStatus
        pincode
        paymentType
        verificationStatus
        verifiedAt
        femaleTimeSlot
        bookingId
        bookingType
        adminPriceAdjustment
        adminPriceAdjustmentReason
        couponDiscount
        codCharges
        couponCode
        issueType
        issueDescription
        issueReportedAt
        issueResolvedAt
        issueResolutionDetails
        attemptedServices
        needsReassignment
        walletAmountUsed
        invoiceNumber
        taxableAmount
        gst
        reason
        declineCategory
        declineReason
        cancelledByType
        totalCommission
        baseCommission
        bonusCommission
        travelCommission
        commissionPercentageUsed
        commissionStatus
        extraKilometers
        isUserToEmpFeedbackCompleted
        feedbackCallStatus
        feedbackCallComment
        feedbackCallAt
        feedbackCallBy
        feedbackCallAttempts
        feedbackIssueStatus
        feedbackIssueDetails
        feedbackResolutionDetails
        cancellationCallStatus
        cancellationCallComment
        adminRemark
        amountPaid
        cashCollected
        adminRecordedAmount
        isAdminAcknowledged
        adminAcknowledgedAt
        razorpayOrderId
        noShowHoldStatus
        paymentSession {
          id
          orderId
          paymentId
          amount
          status
          attemptCount
          lastError
          refundId
          refundStatus
          refundAmount
          refundCreatedAt
          refundArn
          createdAt
        }
        orderDetail {
          id
          name
          serviceId
          price
          specialPrice
          firstTimePrice
          cutPrice
          count
          type
          completionStatus
          incompleteReason
          # Badge + count only - who/when/how is shown from the audit log
          # in View Details (keeps this list query under the server's
          # query-complexity limit of 100).
          addOnCount
        }
        employee {
          id
          fullName
          isDummy
          salaryType
        }
        user {
          id
          fullName
          contactNumber
          isBlocked
        }
      }
    }
  }
`;

const UPDATE_SERVICE_STATUS = gql`
  mutation updateServiceStatus($data: updateServiceInput!) {
    updateServiceStatus(data: $data) {
      status
      message
    }
  }
`;

const UPDATE_ORDER_CALLING_STATUS = gql`
  mutation updateOrderCallingStatus($data: UpdateOrderCallingStatusInput!) {
    updateOrderCallingStatus(data: $data) {
      status
      message
      order {
        adminRemark
      }
    }
  }
`;

const ACKNOWLEDGE_BOOKING = gql`
  mutation acknowledgeBooking($data: ID!) {
    acknowledgeBooking(data: $data) {
      status
      message
      order {
        id
        isAdminAcknowledged
        adminAcknowledgedAt
      }
    }
  }
`;

const RECORD_MANUAL_ONLINE_PAYMENT = gql`
  mutation recordManualOnlinePayment($data: RecordManualOnlinePaymentInput!) {
    recordManualOnlinePayment(data: $data) {
      status
      message
      orderId
      amountPaid
      adminRecordedAmount
      amountDue
    }
  }
`;

export {
  GET_AVAILABLE_EMPLOYEE,
  GET_AVAILABLE_SLOTS,
  EMPLOYEE_LIST,
  CREATE_USER,
  GET_USER_BY_PHONE,
  GET_SERVICES,
  CREATE_BOOKING,
  GET_BOOKINGS,
  EDIT_BOOKING,
  DELETE_BOOKING,
  UPDATE_USER,
  UPDATE_SERVICE_STATUS,
  UPDATE_ORDER_CALLING_STATUS,
  ACKNOWLEDGE_BOOKING,
  RECORD_MANUAL_ONLINE_PAYMENT,
  GET_PREREQUISITE_CHECKLIST_ITEMS,
};
